import React, { useContext } from 'react';
import ThumbtackListing from '/src/Components/ThumbtackListing/ThumbtackListing';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { WindowSizeContext } from '/src/App';
import './style.css';

const ServiceVendorListings = ({
    thumbtackListings,
    handleIFrameClick,
}) => {
    const { deviceType } = useContext(WindowSizeContext);
    const service_networks = [
        { id: 'thumbtack', name: "Thumbtack", url: "https://www.thumbtack.com/", icon: "thumbtack.png" },
        { id: 'angi', name: "Angi", url: "https://www.angi.com/", icon: "angi.png" },
        { id: 'homeadvisor', name: "HomeAdvisor", url: "https://www.homeadvisor.com/", icon: "homeadvisor.png" },
        { id: 'houzz', name: "Houzz", url: "https://www.houzz.com/", icon: "houzz.png" },
    ];

    return (
        <>
            <div className={`service-networks-grid ${deviceType}`}>
                {service_networks.map((network, index) => {
                    return (
                        <>
                            {network.id === 'thumbtack' && (
                                <div className="service-network-icon-container thumbtack">
                                    <img
                                        src={CreateCloudfrontUrl(network.icon)}
                                        alt={network.name}
                                        className="service-network-icon"
                                    />
                                </div>
                            )}
                            {network.id !== 'thumbtack' && (
                                <a
                                    key={index}
                                    href={network.url}
                                    target="_blank"
                                    // rel="noopener noreferrer"
                                    className={`service-network-link ${network.id}`}
                                >
                                    <div className={`service-network-icon-container ${network.id}`}>
                                        <img
                                            src={CreateCloudfrontUrl(network.icon)}
                                            alt={network.name}
                                            className="service-network-icon"
                                        />
                                    </div>
                                </a>
                            )}
                        </>
                    )
                })}
            </div>
            <CurlyBraceDivider />
            <div className={`thumbtack-listings-container ${deviceType}`}>
                {thumbtackListings.map((listing, index) => (
                    <ThumbtackListing
                        key={index}
                        listing={listing}
                        handleIFrameClick={handleIFrameClick}
                    />
                ))}
            </div>
        </>
    )
}

export default ServiceVendorListings;